import { render, staticRenderFns } from "./CreateNotification.vue?vue&type=template&id=4dcd7216&"
import script from "./CreateNotification.vue?vue&type=script&lang=ts&"
export * from "./CreateNotification.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNotification.vue?vue&type=style&index=0&id=4dcd7216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports